import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import swal from 'sweetalert';
import ReactTable from 'react-table';
import { getApplicationList, applicationColumns, massUpdate, getApplicationPersonList, sendEmail } from './actions';
import { spmfcloudFunctionUrl } from '../../../actions/salesforces';
import '../../../assets/css/portal.css';
// import EmailTemplate from './EmailTemplate';

class ApplicationList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            applicationList: [],
            loading: false,
            checkedIds: [],
            isRenewal: false,
            isCheckedAll: false
        };
        
        this.getApplicationList = getApplicationList.bind(this);
        this.applicationColumns = applicationColumns.bind(this);
        this.massUpdate = massUpdate.bind(this);
        this.toggleCheckedList = this.toggleCheckedList.bind(this);
        this.deleteApplication = this.deleteApplication.bind(this);
        this.customFilter = this.customFilter.bind(this);
        this.sendEmail = sendEmail.bind(this);
    }

    componentWillMount() {
        this.getApplicationList();
    }

    customFilter(filter, row) {
        const id = filter.pivotId || filter.id;
        if (row[id] !== null && typeof row[id] === 'string') {
            return (row[id] !== undefined
                ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                : true);
        }
        return this;
    }

    async deleteApplication({status, applicationId, callback = () => {}}) { //for logic delete application (soft delete)
        try {
            if (this.state.loading) return;
            
            this.setState({ loading: true });
            
            const person = await getApplicationPersonList(applicationId, this.props.user.loggedInUser.AccountId,
                'Beneficiary', this.props.user.siteToken.hash, this.props.user.key)
            const beneficiary = person.records
            const dataToUpdate = beneficiary.map(bene => ({Id: bene.Id, Application_Status__c: status}))
            const response = await fetch(`${spmfcloudFunctionUrl}/update-bene-status`, {
                mode: 'cors',
                body: JSON.stringify({
                    data: dataToUpdate,
                    applicationId: applicationId,
                }),
                cache: 'no-cache',
                method: 'POST',
                headers: {
                    'hash-token': this.props.user.siteToken.hash,
                    'Content-Type': 'application/json',
                },
            });

            await this.getApplicationList(true);
            const json = await response.json();
            if (!response.ok) {
                throw new Error(json.message);
            }
        } catch (error) {
            console.log(error)
            swal({
                html: error.toString(),
                title: 'An error occured when updating status',
                type: 'error',
            });
            this.setState({ loading: false });
        } finally{
            this.setState({ loading: false });
            callback()

        }
    }

    toggleCheckedList(e) {
        if (e.target.value === 'on') {
            this.setState({
                isCheckedAll: !this.state.isCheckedAll,
            }, () => {
                if (this.state.isCheckedAll) {
                    const filter = this.props.user.loggedInUser.Partner_Authority__c === 'Approver' ? 'verified by partner' : 'received';
                    const checkedIds = [];
                    for (let i = 0; i < this.state.applicationList.length; i++) {
                        if (this.state.applicationList[i].Application_Status__c.toLowerCase() === filter) {
                            checkedIds.push(this.state.applicationList[i].Id);
                        }
                    }
                    this.setState({
                        checkedIds,
                    });
                }
                else {
                    this.setState({
                        checkedIds: [],
                    });
                }
            });
        }
        else {
            const { checkedIds } = this.state;
            const index = checkedIds.indexOf(e.target.value);
            if (index > -1) checkedIds.splice(index, 1);
            else checkedIds.push(e.target.value);
            this.setState({ checkedIds });
        }

    }

    render() {
        const { loggedInUser } = this.props.user;
        if (this.state.isRenewal) {
            // redirect to registration for renewal of application
            return <Redirect to="/portal/registration" />;
        }

        let sendMail = '';
        sendMail = (
            <div className="btn-group">
                 <button
                        className="btn btn-primary btn-sm"
                        onClick={() => {
                            const data = {
                                "to": ["vipinkkt.75@gmail.com","jatin.s@techmatrixconsulting.com"],
                                "subject": "Test",
                                "text": "Test from spmf",
                                "html": "<p>This is a <b>HTML</b> SPMF email</p>"
                              }
                            this.sendEmail(data)
                        }}
                    >
                        <i className="fa fa-envelope"></i> Send for Approval
                    </button>
            </div>
        )

        // Button for verifying or renewal
        let specialButton = '';
        if (loggedInUser.Partner_Authority__c === 'Approver') {
            specialButton = (
                <div className="btn-group">
                    {/* setVerfCode */}
                    <button
                        className="btn btn-primary btn-sm"
                        onClick={() => this.massUpdate('Approved By Partner')}
                        disabled={this.state.checkedIds.length === 0}
                    >
                        <i className="fa fa-thumbs-up" /> Approve
                    </button>
                    <button
                        className="btn btn-danger btn-sm"
                        onClick={() => this.massUpdate('Rejected By Partner')}
                        disabled={this.state.checkedIds.length === 0}
                    >
                        <i className="fa fa-thumbs-down" /> Reject
                    </button>
                </div>
            );
        } else if (loggedInUser.Partner_Authority__c === 'Verifier' && loggedInUser.Account.Partner_Type__c === 'School') {
            // Disbursing Agency
            specialButton = (
                <button
                    className="btn btn-primary btn-sm"
                    onClick={() => this.massUpdate('Verified By Partner')}
                >
                    <i className="fa fa-thumbs-up" /> Verify
                </button>
            );
        } /* else if (loggedInUser.Account.Partner_Type__c !== 'Disbursing Agency') {
            specialButton = (
                <button className="btn btn-primary btn-sm" onClick={() => this.setState({
                       isRenewal: !this.state.isRenewal
                   })}>
                       <i className="fa fa-thumbs-up" /> Renewal
               </button>
            );
        } */

        return (
            <div className="row">
                
                <div className="col-md-12">
                    <div className="card">
                        <h3>Application List</h3>
                        <p style={{ textAlign: 'center' }}>
                            {this.state.loading ? <i className="fa fa-3x fa-spinner fa-spin" /> : null}
                        </p>
                        <div className="content table-responsive table-full-width">                        
                            <div style={{ float: 'right', margin: '10px 0' }}>
                                {specialButton}
                            </div>
                            <div style={{ float: 'right', margin: '10px 10px' }}>
                                {sendMail}
                            </div>
                            <div className="clearfix" />
                            <ReactTable
                                data={this.state.applicationList}
                                defaultFilterMethod={this.customFilter}
                                columns={this.applicationColumns(this.props.user, this.deleteApplication)}
                                filterable
                                defaultPageSize={10}
                                defaultSorting={[{
                                    id: 'DateSubmitted',
                                    desc: true,
                                }]}
                            />
                        </div>
                    </div>
                   
                </div>
            </div>
        );
    }
}

ApplicationList.propTypes = {
    user: PropTypes.object.isRequired,
    getApplicationList: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({
    getApplicationList,
    sendEmail:(data)=>sendEmail(data),
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
    salesforce: state.salesforce,
    appStatusList: state.objectInfo.Person__c.filter(obj => obj.name === 'Application_Status__c').length ? state.objectInfo.Person__c.filter(obj => obj.name === 'Application_Status__c')[0].picklistValues : [],
});


export default connect(mapStateToProps, mapDispatchToProps)(ApplicationList);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Application/ApplicationList.js
// module id = 788
// module chunks = 0